import { ColorsEnum } from "../et3-theme/colors";

const ALPHA_SCRIM = "8A";
const ALPHA_HAIRLINE = "1F";
const ALPHA_SHADOW = "33";

export const LOADING_Z_INDEX = 200;
export const LOADING_CARD_WIDTH = 210;
export const LOADING_CARD_HEIGHT = 132;
export const LOADING_CARD_RADIUS = 16;
export const LOADING_CARD_GAP = 14;
export const LOADING_SPINNER_SIZE = 46;
export const LOADING_SPINNER_STROKE = 4;
export const LOADING_LABEL_FONT_SIZE = 14;
export const LOADING_LABEL_LETTER_SPACING = 0.6;

export const LOADING_SCRIM = `${ColorsEnum.maastrichtBlue}${ALPHA_SCRIM}`;
export const LOADING_SCRIM_BLUR = "blur(3px)";
export const LOADING_CARD_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const LOADING_CARD_SHADOW = `0 18px 44px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW}`;
